// extracted by mini-css-extract-plugin
export default {"invoicesTable":"tudYCIVfmf1_p1X_q3gx"};